import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import {
  StoreApplication,
  StoreApplicationActions,
} from "../../domain/store";
import { getStoreUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const getStoreService = {
  async execute(): Promise<StoreApplication> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(getStoreUrl);

    const response: RestResponse = await restClient().sendRequest(
      url,
      "GET"
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;

      throw DaccachErrorActions().createError(errorMessage);
    }

    return StoreApplicationActions().deserialize(response.content);
  },
};